// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"34":"category","136":"events","963":"event"}[chunkId] + "." + {"34":"da3704b9","136":"c191060a","963":"da3704b9"}[chunkId] + ".css";
};